export default {
	cs: "čeština",
	de: "Deutsch",
	en: "English",
}